export function embedAssetResizer(width, height) {

    return {
        width,
        height,

        get ratio() {
            return this.height / this.width;
        },

        get inverseRatio() {
            return this.width / this.height;
        },

        init() {
            window.addEventListener('resize', () => {
                this.resize();
            });

            this.resize();
        },

        resize() {
            // The iframe may not be in the DOM yet (e.g. gated behind cookie consent);
            // bail out and let x-init re-trigger us once it renders.
            if (!this.$refs.iframe) return;

            const w = this.$root.offsetWidth;
            const h = this.$root.offsetHeight;

            const containerRatio = h / w;

            if (containerRatio > this.ratio) {
                this.$refs.iframe.style.width = `${h * (this.inverseRatio)}px`;
                this.$refs.iframe.style.height = `${h}px`;
            } else {
                this.$refs.iframe.style.width = `${w}px`;
                this.$refs.iframe.style.height = `${w * (this.ratio)}px`;
            }
        }

    };
}